import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { b } from "framer-motion/client";

const Footer = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        const yOffset = -200; // Stop 200px before the top
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  // bootom to top button functionality
  const [showTopBtn, setShowTopBtn] = React.useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const back_to_top = location.pathname;
  const buttonClass = `back_to_top ${back_to_top === "/services" ? "back_to_top_services" : ""}`;

  return (
    <>
      <footer className="footer">
        <div className="footer_container">
          <div className="footer_row">
            <div className="foot_logo_col footer_col">
              <img
                src="/assets/img/Sky-footer-logo-light.webp"
                alt="Sky47 - Pakistan's Leading AI Data Center"
                width={250}
                height={193}
                loading="lazy"
              />
            </div>
            <div className="company_links_col footer_col">
              <div className="footer_inner_sec">
                <h5>Company</h5>
                <ul>
                  <li
                    className={location.pathname === "/about" ? "active" : ""}
                  >
                    <Link to="/about">About Us</Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/facilities" ? "active" : ""
                    }
                  >
                    <Link to="/facilities">DC Campus</Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/leadership" ? "active" : ""
                    }
                  >
                    <Link to="/leadership">Sky47 Leadership</Link>
                  </li>
                  <li
                    className={location.pathname === "/careers" ? "active" : ""}
                  >
                    <Link to="/careers">Careers</Link>
                  </li>
                  <li
                    className={location.pathname === "/contact" ? "active" : ""}
                  >
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="important_links_col footer_col">
              <div className="footer_inner_sec">
                <h5>Important Links</h5>
                <ul>
                  <li>
                    <Link to="/services/1228">Sky47 Space</Link>
                  </li>
                  <li>
                    <Link to="/services/1262">Sky47 Cloud</Link>
                  </li>
                  <li>
                    <Link to="/services/1308">Sky47 Secure</Link>
                  </li>
                  <li>
                    <Link to="/services/1306">Sky47 Manage</Link>
                  </li>
                  <li>
                    <Link to="/services/1310">Sky47 AI</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="foot_about_col footer_col">
              <div className="footer_right">
                <ul className="contact_info">
                  <li>
                    <a href="mailto:info@sky47.com.pk">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="19"
                        viewBox="0 0 25 19"
                        fill="none"
                      >
                        <path
                          d="M23.1948 0.276367H1.31651C1.13518 0.276367 0.961281 0.348399 0.833062 0.476617C0.704844 0.604835 0.632812 0.778736 0.632812 0.960065V16.4572C0.632812 16.8803 0.800888 17.2861 1.10006 17.5852C1.39924 17.8845 1.80501 18.0525 2.22811 18.0525H22.2832C22.7063 18.0525 23.1121 17.8845 23.4113 17.5852C23.7104 17.2861 23.8785 16.8803 23.8785 16.4572V0.960065C23.8785 0.778736 23.8065 0.604835 23.6783 0.476617C23.5501 0.348399 23.3761 0.276367 23.1948 0.276367ZM12.2557 10.0601L3.07361 1.64376H21.4377L12.2557 10.0601ZM9.25537 9.16443L2.00021 15.8145V2.51434L9.25537 9.16443ZM10.2672 10.092L11.7999 11.4913C11.9259 11.6066 12.0905 11.6705 12.2614 11.6705C12.4322 11.6705 12.5968 11.6066 12.7229 11.4913L14.2498 10.092L21.4377 16.6851H3.07475L10.2672 10.092ZM15.256 9.16443L22.5111 2.51434V15.8145L15.256 9.16443Z"
                          fill="#28B34B"
                        />
                      </svg>{" "}
                      info@sky47.com.pk
                    </a>
                  </li>
                  {/* <li>
                                        <a href="tel:+923000990810">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28"
                                                fill="none">
                                                <path
                                                    d="M18.7085 16.9098C18.8557 16.8118 19.0251 16.752 19.2014 16.7361C19.3775 16.72 19.5549 16.7482 19.7174 16.818L25.9869 19.6271C26.1983 19.7174 26.3746 19.8737 26.4896 20.0726C26.6046 20.2715 26.6521 20.5023 26.625 20.7304C26.4185 22.274 25.6585 23.69 24.4862 24.7151C23.3139 25.7401 21.8091 26.3046 20.2519 26.3033C15.4568 26.3033 10.858 24.3986 7.46739 21.0079C4.07672 17.6173 2.17188 13.0185 2.17188 8.2234C2.17069 6.66613 2.73512 5.16144 3.76021 3.98913C4.78529 2.81683 6.20125 2.05674 7.74477 1.8502C7.97294 1.8231 8.20375 1.87061 8.40266 1.98564C8.60157 2.10067 8.75788 2.27703 8.84818 2.48832L11.6572 8.76314C11.7262 8.9243 11.7543 9.10003 11.739 9.27468C11.7237 9.44933 11.6655 9.61749 11.5695 9.76418L8.72854 13.1422C8.62777 13.2942 8.56817 13.4699 8.55558 13.6518C8.543 13.8339 8.57786 14.016 8.65674 14.1804C9.75616 16.4312 12.0826 18.7298 14.34 19.8185C14.5053 19.8971 14.6883 19.9312 14.8709 19.9174C15.0533 19.9037 15.2292 19.8426 15.3809 19.7401L18.7085 16.9098Z"
                                                    stroke="#28B34B" strokeWidth="1.82319" strokeLinecap="round"
                                                    strokeLinejoin="round" />
                                            </svg> +92 300-0990810
                                        </a>
                                    </li> */}
                  <li>
                    <a
                      href="https://maps.app.goo.gl/oFL52vNgstD7gkHq5"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="View Sky47 location on Google Maps"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="27"
                        viewBox="0 0 22 27"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M11.0419 6.30161C10.1854 6.30161 9.34826 6.55557 8.63619 7.03136C7.92411 7.50715 7.3691 8.18342 7.04138 8.97464C6.71364 9.76586 6.62789 10.6365 6.79497 11.4765C6.96205 12.3164 7.37445 13.088 7.98002 13.6935C8.58559 14.2991 9.35714 14.7115 10.1971 14.8786C11.0371 15.0456 11.9077 14.9599 12.6989 14.6322C13.4901 14.3044 14.1664 13.7494 14.6421 13.0374C15.118 12.3253 15.3719 11.4881 15.3719 10.6317C15.3719 9.48329 14.9157 8.38191 14.1037 7.56986C13.2916 6.75781 12.1903 6.30161 11.0419 6.30161ZM11.0419 13.5943C10.4559 13.5943 9.88308 13.4206 9.39587 13.095C8.90866 12.7695 8.52892 12.3068 8.30468 11.7655C8.08044 11.2241 8.02177 10.6284 8.13608 10.0537C8.25041 9.479 8.53257 8.9511 8.94692 8.53676C9.36126 8.12242 9.88916 7.84025 10.4639 7.72594C11.0386 7.61162 11.6343 7.67029 12.1756 7.89452C12.717 8.11876 13.1797 8.4985 13.5052 8.98571C13.8308 9.47292 14.0045 10.0457 14.0045 10.6317C14.0045 11.4175 13.6924 12.171 13.1368 12.7266C12.5812 13.2822 11.8276 13.5943 11.0419 13.5943ZM11.0419 0.832031C8.44374 0.835047 5.95291 1.86848 4.11577 3.70561C2.27864 5.54276 1.2452 8.03358 1.24219 10.6317C1.24219 14.1539 2.87622 17.8949 5.96768 21.4501C7.363 23.0625 8.93339 24.5149 10.6499 25.7802C10.7648 25.8605 10.9016 25.9037 11.0419 25.9037C11.1821 25.9037 11.3189 25.8605 11.4338 25.7802C13.1503 24.5149 14.7207 23.0625 16.116 21.4501C19.2075 17.8949 20.8415 14.1573 20.8415 10.6317C20.8384 8.03358 19.8051 5.54276 17.9679 3.70561C16.1308 1.86848 13.64 0.835047 11.0419 0.832031ZM11.0419 24.3638C9.33261 23.0442 2.60958 17.4253 2.60958 10.6317C2.60958 8.39532 3.49798 6.25054 5.07933 4.66918C6.6607 3.08782 8.80548 2.19943 11.0419 2.19943C13.2783 2.19943 15.4229 3.08782 17.0044 4.66918C18.5857 6.25054 19.4741 8.39532 19.4741 10.6317C19.4741 17.4253 12.7511 23.0442 11.0419 24.3638Z"
                          fill="#28B34B"
                        />
                      </svg>
                      Building No. 1-C Kohistan Road, F-8 Markaz, Islamabad
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://maps.app.goo.gl/oFL52vNgstD7gkHq5"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="View Sky47 location on Google Maps"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Telephone"
                        viewBox="0 0 32 32"
                        width="32"
                        height="32"
                      >
                        <path
                          fill="#28b34b"
                          d="M28.5 25h-22c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h22c.3 0 .5.2.5.5s-.2.5-.5.5zM22.5 17.5h-2.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.1c.3 0 .5.2.5.5s-.2.5-.5.5zM24.5 12c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5h-4zM10.5 12h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5z"
                          class="color4f5266 svgShape"
                        ></path>
                        <path
                          fill="#28b34b"
                          d="M26.6 27H8.4c-.8 0-1.5-.3-1.9-.9-.5-.6-.7-1.4-.5-2.1l1.3-6.5c.2-.9.8-1.6 1.7-1.9l.5-.2c.6-.2 1-.8 1-1.4v-3.6c0-.7.7-1.4 1.5-1.4h11c.8 0 1.5.7 1.5 1.5v3.6c0 .6.4 1.2 1 1.4l.5.2c.8.3 1.5 1 1.7 1.9L29 24c.1.7 0 1.5-.5 2.1-.5.6-1.2.9-1.9.9zM12 10c-.3 0-.5.2-.5.5v3.6c0 1.1-.7 2-1.7 2.4l-.5.2c-.5.2-.9.6-1 1.1L7 24.2c-.1.4 0 .9.3 1.2s.7.6 1.1.6h18.1c.5 0 .9-.2 1.2-.5s.4-.8.3-1.2l-1.3-6.5c-.1-.5-.5-1-1-1.1l-.5-.2c-1-.3-1.7-1.3-1.7-2.4v-3.6c0-.3-.2-.5-.5-.5H12z"
                          class="color4f5266 svgShape"
                        ></path>
                        <path
                          fill="#28b34b"
                          d="M17.5 22c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-9c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
                          class="color4f5266 svgShape"
                        ></path>
                        <path
                          fill="#28b34b"
                          d="M17.5 20c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                          class="color4f5266 svgShape"
                        ></path>
                        <path
                          fill="#28b34b"
                          d="M28 15h-3.2c-.5 0-1-.2-1.2-.7-.1-.1-.1-.2-.1-.3v-3.6c0-.3-.2-.5-.5-.5H12c-.3 0-.5.2-.5.5V14c0 .1 0 .2-.1.3-.3.4-.7.7-1.2.7H7c-.8 0-1.5-.7-1.5-1.5v-2.7c0-1.6.8-3.1 2.2-3.9C9.8 5.7 12.1 5 14.6 5h5.9c2.4 0 4.8.7 6.9 1.9 1.3.8 2.2 2.3 2.2 3.9v2.7c-.1.8-.8 1.5-1.6 1.5zm-3.5-1.1c.1.1.2.1.3.1H28c.3 0 .5-.2.5-.5v-2.7c0-1.2-.7-2.4-1.7-3C24.9 6.6 22.7 6 20.4 6h-5.9c-2.2 0-4.4.6-6.4 1.8-1 .6-1.7 1.8-1.7 3v2.7c.1.3.3.5.6.5h3.2c.1 0 .2 0 .3-.1v-3.4c0-.8.7-1.5 1.5-1.5h11c.8 0 1.5.7 1.5 1.5v3.4zM4 22c-.8 0-1.5-.7-1.5-1.5S3.2 19 4 19c.3 0 .5.2.5.5s-.2.5-.5.5-.5.2-.5.5.2.5.5.5.5.2.5.5-.2.5-.5.5z"
                          class="color4f5266 svgShape"
                        ></path>
                        <path
                          fill="#28b34b"
                          d="M4 24c-.8 0-1.5-.7-1.5-1.5S3.2 21 4 21c.3 0 .5.2.5.5s-.2.5-.5.5-.5.2-.5.5.2.5.5.5.5.2.5.5-.2.5-.5.5zM4 20c-.8 0-1.5-.7-1.5-1.5S3.2 17 4 17c.3 0 .5.2.5.5s-.2.5-.5.5-.5.2-.5.5.2.5.5.5.5.2.5.5-.2.5-.5.5z"
                          class="color4f5266 svgShape"
                        ></path>
                        <path
                          fill="#28b34b"
                          d="M4 18c-.8 0-1.5-.7-1.5-1.5S3.2 15 4 15c.3 0 .5.2.5.5s-.2.5-.5.5-.5.2-.5.5.2.5.5.5.5.2.5.5-.2.5-.5.5z"
                          class="color4f5266 svgShape"
                        ></path>
                        <path
                          fill="#28b34b"
                          d="M4 16c-.3 0-.5-.2-.5-.5v-1c0-.8.7-1.5 1.5-1.5h1c.3 0 .5.2.5.5s-.2.5-.5.5H5c-.3 0-.5.2-.5.5v1c0 .3-.2.5-.5.5z"
                          class="color4f5266 svgShape"
                        ></path>
                      </svg>
                      051-111-1SKY47
                    </a>
                  </li>
                </ul>
                <h5 className="footer_title">
                  Follow us for updates on <br /> AI, Cloud, and Data
                  Infrastructure in Pakistan
                </h5>
                <ul className="footer_socials">
                  <li>
                    <a
                      href="https://www.linkedin.com/company/sky47limited/?originalSubdomain=pk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="linkedin"
                      aria-label="Follow Sky47 on LinkedIn"
                    >
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M24.375 0.625C25.3711 0.625 26.25 1.50391 26.25 2.55859V25C26.25 26.0547 25.3711 26.875 24.375 26.875H1.81641C0.820312 26.875 0 26.0547 0 25V2.55859C0 1.50391 0.820312 0.625 1.81641 0.625H24.375ZM7.91016 23.125V10.6445H4.04297V23.125H7.91016ZM5.97656 8.88672C7.20703 8.88672 8.20312 7.89062 8.20312 6.66016C8.20312 5.42969 7.20703 4.375 5.97656 4.375C4.6875 4.375 3.69141 5.42969 3.69141 6.66016C3.69141 7.89062 4.6875 8.88672 5.97656 8.88672ZM22.5 23.125V16.2695C22.5 12.9297 21.7383 10.293 17.8125 10.293C15.9375 10.293 14.6484 11.3477 14.1211 12.3438H14.0625V10.6445H10.3711V23.125H14.2383V16.9727C14.2383 15.332 14.5312 13.75 16.582 13.75C18.5742 13.75 18.5742 15.625 18.5742 17.0312V23.125H22.5Z"
                          fill="#28A8E0"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=61579239627650"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="facebook"
                      aria-label="Follow Sky47 on Facebook"
                    >
                      <svg
                        width="35"
                        height="35"
                        viewBox="0 0 30 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M30 15.75C30 23.4258 24.1992 29.7539 16.8164 30.6914V20.3789H20.8594L21.6797 15.75H16.8164V14.168C16.8164 11.707 17.7539 10.7695 20.2148 10.7695C20.9766 10.7695 21.5625 10.8281 21.9141 10.8281V6.72656C21.2695 6.49219 19.6289 6.31641 18.6914 6.31641C13.6523 6.31641 11.3672 8.71875 11.3672 13.8164V15.75H8.26172V20.3789H11.3672V30.3398C4.80469 28.6992 0 22.7812 0 15.75C0 7.48828 6.67969 0.75 15 0.75C23.2617 0.75 30 7.48828 30 15.75Z"
                          fill="#28A8E0"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/sky47pakistan?igsh=OGgzc2I5Z2dteGZp&utm_source=qr"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="instagram"
                      aria-label="Follow Sky47 on Instagram"
                    >
                      <svg
                        width="35"
                        height="35"
                        viewBox="0 0 28 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M14.125 7.01172C17.8164 7.01172 20.8633 10.0586 20.8633 13.75C20.8633 17.5 17.8164 20.4883 14.125 20.4883C10.375 20.4883 7.38672 17.5 7.38672 13.75C7.38672 10.0586 10.375 7.01172 14.125 7.01172ZM14.125 18.1445C16.5273 18.1445 18.4609 16.2109 18.4609 13.75C18.4609 11.3477 16.5273 9.41406 14.125 9.41406C11.6641 9.41406 9.73047 11.3477 9.73047 13.75C9.73047 16.2109 11.7227 18.1445 14.125 18.1445ZM22.6797 6.77734C22.6797 5.89844 21.9766 5.19531 21.0977 5.19531C20.2188 5.19531 19.5156 5.89844 19.5156 6.77734C19.5156 7.65625 20.2188 8.35938 21.0977 8.35938C21.9766 8.35938 22.6797 7.65625 22.6797 6.77734ZM27.1328 8.35938C27.25 10.5273 27.25 17.0312 27.1328 19.1992C27.0156 21.3086 26.5469 23.125 25.0234 24.707C23.5 26.2305 21.625 26.6992 19.5156 26.8164C17.3477 26.9336 10.8438 26.9336 8.67578 26.8164C6.56641 26.6992 4.75 26.2305 3.16797 24.707C1.64453 23.125 1.17578 21.3086 1.05859 19.1992C0.941406 17.0312 0.941406 10.5273 1.05859 8.35938C1.17578 6.25 1.64453 4.375 3.16797 2.85156C4.75 1.32812 6.56641 0.859375 8.67578 0.742188C10.8438 0.625 17.3477 0.625 19.5156 0.742188C21.625 0.859375 23.5 1.32812 25.0234 2.85156C26.5469 4.375 27.0156 6.25 27.1328 8.35938ZM24.3203 21.4844C25.0234 19.7852 24.8477 15.6836 24.8477 13.75C24.8477 11.875 25.0234 7.77344 24.3203 6.01562C23.8516 4.90234 22.9727 3.96484 21.8594 3.55469C20.1016 2.85156 16 3.02734 14.125 3.02734C12.1914 3.02734 8.08984 2.85156 6.39062 3.55469C5.21875 4.02344 4.33984 4.90234 3.87109 6.01562C3.16797 7.77344 3.34375 11.875 3.34375 13.75C3.34375 15.6836 3.16797 19.7852 3.87109 21.4844C4.33984 22.6562 5.21875 23.5352 6.39062 24.0039C8.08984 24.707 12.1914 24.5312 14.125 24.5312C16 24.5312 20.1016 24.707 21.8594 24.0039C22.9727 23.5352 23.9102 22.6562 24.3203 21.4844Z"
                          fill="#28A8E0"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtube.com/@sky47pakistan?si=NGMyDsBA5O3WDphg"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="youtube"
                      aria-label="Subscribe to Sky47 on YouTube"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="external-icon"
                        viewBox="0 0 28.57 20"
                        focusable="false"
                        width="30"
                        height="30"
                        aria-hidden="true"
                        style={{
                          pointerEvents: "none",
                          display: "block",
                        }}
                      >
                        <svg
                          viewBox="0 0 28.57 20"
                          preserveAspectRatio="xMidYMid meet"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <path
                              d="M27.9727 3.12324C27.6435 1.89323 26.6768 0.926623 25.4468 0.597366C23.2197 2.24288e-07 14.285 0 14.285 0C14.285 0 5.35042 2.24288e-07 3.12323 0.597366C1.89323 0.926623 0.926623 1.89323 0.597366 3.12324C2.24288e-07 5.35042 0 10 0 10C0 10 2.24288e-07 14.6496 0.597366 16.8768C0.926623 18.1068 1.89323 19.0734 3.12323 19.4026C5.35042 20 14.285 20 14.285 20C14.285 20 23.2197 20 25.4468 19.4026C26.6768 19.0734 27.6435 18.1068 27.9727 16.8768C28.5701 14.6496 28.5701 10 28.5701 10C28.5701 10 28.5677 5.35042 27.9727 3.12324Z"
                              fill="#28A8E0"
                            ></path>
                            <path
                              d="M11.4253 14.2854L18.8477 10.0004L11.4253 5.71533V14.2854Z"
                              fill="white"
                            ></path>
                          </g>
                        </svg>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://x.com/Sky47297874"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="twitter"
                      aria-label="Follow Sky47 on X (Twitter)"
                    >
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 28 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M21.793 0.5625H25.8945L16.8711 10.9336L27.5352 24.9375H19.2148L12.6523 16.4414L5.21094 24.9375H1.05078L10.7188 13.9219L0.523438 0.5625H9.07812L14.9375 8.35547L21.793 0.5625ZM20.3281 22.4766H22.6133L7.84766 2.90625H5.38672L20.3281 22.4766Z"
                          fill="#28A8E0"
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer_bottom">
          <div className="footer_container">
            <p>
              ©2025 Sky47 |{" "}
              <a href="#" aria-label="View Privacy Policy">
                Privacy Policy
              </a>{" "}
              |{" "}
              <a href="#" aria-label="View Cookie Policy">
                Cookie Policy
              </a>
            </p>
          </div>
        </div>
      </footer>
      {showTopBtn && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className={buttonClass}
          aria-label="Back to Top"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.7806 12.5306L14.0306 19.2806C13.8899 19.4213 13.699 19.5003 13.5 19.5003C13.301 19.5003 13.1101 19.4213 12.9694 19.2806C12.8286 19.1398 12.7496 18.949 12.7496 18.7499C12.7496 18.5509 12.8286 18.36 12.9694 18.2193L18.4397 12.7499H3.75C3.55109 12.7499 3.36032 12.6709 3.21967 12.5303C3.07902 12.3896 3 12.1988 3 11.9999C3 11.801 3.07902 11.6103 3.21967 11.4696C3.36032 11.3289 3.55109 11.2499 3.75 11.2499H18.4397L12.9694 5.78055C12.8286 5.63982 12.7496 5.44895 12.7496 5.24993C12.7496 5.05091 12.8286 4.86003 12.9694 4.7193C13.1101 4.57857 13.301 4.49951 13.5 4.49951C13.699 4.49951 13.8899 4.57857 14.0306 4.7193L20.7806 11.4693C20.8504 11.539 20.9057 11.6217 20.9434 11.7127C20.9812 11.8038 21.0006 11.9014 21.0006 11.9999C21.0006 12.0985 20.9812 12.1961 20.9434 12.2871C20.9057 12.3782 20.8504 12.4609 20.7806 12.5306Z"
              fill="black"
            />
          </svg>
        </button>
      )}
      <div id="preloader" className="preloader">
        <div className="preloader-content">
          <div className="logo-container">
            <img src="/assets/img/loader_com.gif" alt="loader" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
